export default __webpack_public_path__ + "static/media/challenges@3x.bbe9a6db.jpg";